import { DateTime } from 'luxon'

const state = {
  amount: undefined,
  campaign_id: undefined,
  date_received: DateTime.now().toFormat('yyyy-MM-dd'),
  id: null,
  paid_by: 'vendor',
  payment_method: 'EFT',
  payment_received: undefined,
  receipt_data: '',
  reference: '',
  user_id: undefined,
}

export const requiredFields = [
  { key: 'amount' },
  { key: 'campaign_id' },
  { key: 'date_received' },
  { key: 'paid_by' },
  { key: 'payment_method' },
  { key: 'reference' },
]

export default state
